<template>
  <div>
    <!-- Header -->
    <div class="content-header row">
      <div class="content-header-left col-md-6 col-12 mb-2">
        <div class="row breadcrumbs-top">
          <div class="breadcrumb-wrapper col-12">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Inicio</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'catalogo' }">Catálogo</router-link>
              </li>
              <li class="breadcrumb-item active">Fases</li>
            </ol>
          </div>
        </div>
        <h3 class="content-header-title mb-0">Gestión de Fases</h3>
      </div>
      <div class="content-header-right col-md-6 col-12">
        <div class="btn-group float-md-right" role="group">
          <b-button
            variant="primary"
            @click="showModal = true"
            v-b-modal.modal-fase
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            Nueva Fase
          </b-button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Lista de Fases</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <!-- Indicador de carga -->
              <div v-if="cargando" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
                <p class="mt-2">Cargando fases...</p>
              </div>
              
              <!-- Tabla de datos -->
              <div v-else class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="fases.length === 0">
                      <td colspan="3" class="text-center py-4">
                        <p class="text-muted">No hay fases registradas</p>
                      </td>
                    </tr>
                    <tr v-for="fase in fases" :key="fase.idFase">
                      <td>{{ fase.idFase }}</td>
                      <td>{{ fase.nombre }}</td>
                      <td>
                        <b-button
                          variant="outline-primary"
                          size="sm"
                          @click="editarFase(fase)"
                          class="mr-1"
                        >
                          <feather-icon icon="EditIcon" size="14" />
                        </b-button>
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          @click="eliminarFase(fase.idFase)"
                        >
                          <feather-icon icon="TrashIcon" size="14" />
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <b-modal
      id="modal-fase"
      :title="modoEdicion ? 'Editar Fase' : 'Nueva Fase'"
      @ok="guardarFase"
      @cancel="limpiarFormulario"
      :ok-disabled="guardando"
      :cancel-disabled="guardando"
    >
      <b-form @submit.prevent="guardarFase">
        <b-form-group label="Nombre:" label-for="nombre">
          <b-form-input
            id="nombre"
            v-model="formulario.nombre"
            placeholder="Ingrese el nombre de la fase"
            :disabled="guardando"
            required
          ></b-form-input>
        </b-form-group>
      </b-form>
      
      <!-- Indicador de carga en el modal -->
      <div v-if="guardando" class="text-center py-2">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="sr-only">Guardando...</span>
        </div>
        <span class="ml-2">Guardando...</span>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BButton, BModal, BForm, BFormGroup, BFormInput } from 'bootstrap-vue'
import { CatalogoFasesMixin } from '@/@core/mixins/catalogos'

export default {
  name: 'CatalogoFases',
  components: {
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
  },
  mixins: [CatalogoFasesMixin],
}
</script>






